<template>
  <div>
    <input type="checkbox"
           class="custom-checkbox"
           :id="id"

           :name="name || id"
           v-model="internalValue"
           :value="value"
           :disabled="disabled">
    <label :for="id">{{text}}</label>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    value: [Number, String, Object],
    text: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/theme/default/colors";
.custom-checkbox {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-checkbox + label {
  display: inline-flex;
  align-items: center;
  user-select: none;
  font-weight: normal !important;
}

.custom-checkbox + label::before {
  content: '';
  display: inline-block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid $gray-medium;
  border-radius: 4px;
  margin-right: 8px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-checkbox:checked + label::before {

  border-color: $blue-light;
  background-color: $blue-light;
  background-image: url("../../assets/svg/checkbox.svg");
}

.custom-checkbox:not(:disabled):not(:checked) + label:hover::before {
  border-color: $blue-light1;
}

.custom-checkbox:not(:disabled):active + label::before {
  background-color: $blue-light1;
  border-color: $blue-light1;
}

.custom-checkbox:disabled + label::before {

}
</style>